import React__default, { Fragment } from 'react';
import { skipTokensCssVariables } from '@jet-pie/theme/variations/skip';
import { createGlobalStyle, ThemeProvider } from 'styled-components';

const GlobalStyle = createGlobalStyle `
    @font-face {
      font-family: 'JETSansDigital';
      font-weight: 400;
      font-style: normal;
      src: url('https://d30v2pzvrfyzpo.cloudfront.net/fonts/JETSansDigital-Regular-optimised.woff') format('woff'),
      url('https://d30v2pzvrfyzpo.cloudfront.net/fonts/JETSansDigital-Regular-optimised.woff2') format('woff2');
    }
    @font-face {
      font-family: 'JETSansDigital';
      font-weight: 700;
      font-style: normal;
      src: url('https://d30v2pzvrfyzpo.cloudfront.net/fonts/JETSansDigital-Bold-optimised.woff') format('woff'),
      url('https://d30v2pzvrfyzpo.cloudfront.net/fonts/JETSansDigital-Bold-optimised.woff2') format('woff2');
    }
    @font-face {
      font-family: 'JETSansDigital';
      font-weight: 800;
      font-style: normal;
      src: url('https://d30v2pzvrfyzpo.cloudfront.net/fonts/JETSansDigital-ExtraBold-optimised.woff') format('woff'),
      url('https://d30v2pzvrfyzpo.cloudfront.net/fonts/JETSansDigital-ExtraBold-optimised.woff2') format('woff2');
    }
  `;
const PIEThemeProvider = (props) => {
    const theme = Object.assign(Object.assign(Object.assign({}, skipTokensCssVariables), props.customTheme), { custom: Object.assign({}, props.additionalProps), mode: props.mode });
    return (React__default.createElement(Fragment, null,
        React__default.createElement(GlobalStyle, null),
        React__default.createElement(ThemeProvider, { theme: theme }, props.children)));
};

export { PIEThemeProvider };
